export async function fetchData(url, options = {}) {
  const response = await fetch(url, options).catch(function (error) {
    console.error(error);
  });

  if(!response) {
    return null;
  }

  if (!response.ok) {
    throw new Error(`An error has occured: ${response.status}`);
  }

  const data = await response.json();
  return data;
}
